<template>
  <ItemDialog ref="DialogGeneralPuchaseWarning" image-type="alert">
    <template #content-area>
      <h2>購入エラー</h2>
      <p class="text-justify">
        <br />
        お手数ですがもう一度購入手続きをやり直してください。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="OK"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogGeneralPuchaseWarning",
  props: {
    closeClick: {
      type: Function,
      required: false,
    },
  },
  setup(props) {
    const DialogGeneralPuchaseWarning = ref(null);

    const openDialog = () => {
      DialogGeneralPuchaseWarning.value.open();
    };

    const closeDialog = () => {
      if (props.closeClick) {
        props.closeClick();
      }
      DialogGeneralPuchaseWarning.value.close();
    };

    return {
      DialogGeneralPuchaseWarning,
      openDialog,
      closeDialog,
    };
  },
};
</script>

<style scoped lang="scss">
.text-justify {
  text-align: justify;
}
</style>
